import { HashRouter } from 'react-router-dom';
import initRouter from './router';
const App = () => {
  return (
    <HashRouter>
      {initRouter()}
    </HashRouter>
  );
}
export default App;
